module.exports = __webpack_public_path__ + "static/assets/8c2eb0ad66655af1ef50a948a00418fb.svg";